import { useState } from 'react'
import IconArrowRight from '../../../assets/icons/icon-arrow-right.svg'
import IconArrowDown from '../../../assets/icons/icon-arrow-down.svg'
import * as S from './styles'
import { dateFromString } from '../../Filter/masks'
import {
  convertDecimalCurrency,
  convertDecimalPercentage
} from '../../../utils/utils'
import { VendasPromovidasData } from '../../../types/vendasPromovidas'

type TableVendasPromovidasProps = {
  data: Array<VendasPromovidasData>
}

const TableVendasPromovidas = ({ data }: TableVendasPromovidasProps) => {
  const [showDetails, setShowDetails] = useState({
    showDetails: false
  })

  const [sortInfo, setSortInfo] = useState<any>(['', false])

  const handleShowDetail = (cardDetail) => {
    setShowDetails({
      ...showDetails,
      [cardDetail]: !showDetails[cardDetail]
    })
  }

  return (
    <>
      {data ? (
        <S.Wrapper>
          <S.TableDesktop className="table-primary">
            <thead>
              <tr>
                <th
                  id="pedidoId"
                  onClick={(e) => setSortInfo(['pedidoId', !sortInfo[1]])}
                >
                  Pedido
                </th>
                <th
                  id="DataPedido"
                  onClick={(e) => setSortInfo(['DataPedido', !sortInfo[1]])}
                >
                  Data
                </th>
                <th
                  id="NomeCliente"
                  className="mobile-view"
                  onClick={(e) => setSortInfo(['NomeCliente', !sortInfo[1]])}
                >
                  Cliente
                </th>
                <th
                  id="ValorPedidoTotal"
                  className="mobile-view"
                  onClick={(e) =>
                    setSortInfo(['ValorPedidoTotal', !sortInfo[1]])
                  }
                >
                  Vl. Pedido
                </th>
                <th
                  id="ValorTotalProdutos"
                  className="mobile-view"
                  onClick={(e) =>
                    setSortInfo(['ValorTotalProdutos', !sortInfo[1]])
                  }
                >
                  Vl. Produtos
                </th>
                <th
                  id="PercentualCommissao"
                  className="mobile-view"
                  onClick={(e) =>
                    setSortInfo(['PercentualComissao', !sortInfo[1]])
                  }
                >
                  Comissão
                </th>
                <th
                  id="TotalComissao"
                  onClick={(e) => setSortInfo(['TotalComissao', !sortInfo[1]])}
                >
                  Gimplus
                </th>
              </tr>
            </thead>

            <tbody>
              {data
                ?.sort((a, b) => {
                  if (sortInfo[0] === 'DataPedido') {
                    let A: any = new Date(a[sortInfo[0]])
                    let B: any = new Date(b[sortInfo[0]])
                    return sortInfo[1] ? A - B : B - A
                  }
                  if (sortInfo[0] === 'NomeCliente') {
                    if (a[sortInfo[0]] < b[sortInfo[0]])
                      return sortInfo[1] ? 1 : -1
                    if (a[sortInfo[0]] > b[sortInfo[0]])
                      return sortInfo[1] ? -1 : 1
                    return 0
                  }
                  let A = a[sortInfo[0]]
                  let B = b[sortInfo[0]]
                  return sortInfo[1] ? A - B : B - A
                })
                .map((item, index) => {
                  return (
                    <>
                      <S.TableRow
                        className="view"
                        key={`${item.pedidoId}-${index}`}
                        show={showDetails[index]}
                        onClick={() => {
                          handleShowDetail(index)
                        }}
                      >
                        <td>{item.pedidoId}</td>

                        <td>{dateFromString(item.DataPedido)}</td>

                        <td className="mobile-view">{item.NomeCliente}</td>

                        <td className="mobile-view currency">
                          {convertDecimalCurrency(item.ValorPedidoTotal)}
                        </td>

                        <td className="mobile-view currency">
                          {convertDecimalCurrency(item.ValorTotalProdutos)}{' '}
                        </td>
                        <td className="mobile-view">
                          {convertDecimalPercentage(item.PercentualCommissao)}%
                        </td>
                        <td className="currency">
                          {convertDecimalCurrency(item.TotalComissao)}

                          <button className="link detail-arrow">
                            {showDetails[index] === true ? (
                              <img src={IconArrowDown} alt="" />
                            ) : (
                              <img src={IconArrowRight} alt="" />
                            )}
                          </button>
                        </td>
                      </S.TableRow>

                      <S.Details
                        className="view-details"
                        key={index}
                        show={showDetails[index]}
                      >
                        <td>
                          <ul>
                            <li>
                              <strong>Cliente:</strong> {item.NomeCliente}
                            </li>
                            <li>
                              <strong>Vl. Pedido: </strong>
                              {convertDecimalCurrency(item.ValorPedidoTotal)}
                            </li>
                            <li>
                              <strong>Vl. Produtos: </strong>
                              {convertDecimalCurrency(item.ValorTotalProdutos)}
                            </li>
                            <li>
                              <strong>% Comissão: </strong>{' '}
                              {convertDecimalPercentage(
                                item.PercentualCommissao
                              )}
                              %
                            </li>
                          </ul>
                        </td>
                      </S.Details>
                    </>
                  )
                })}
            </tbody>
          </S.TableDesktop>
        </S.Wrapper>
      ) : null}
    </>
  )
}

export default TableVendasPromovidas
